// utils/fecha.js
// Las fechas del backend (MySQL/PHP) se generan y almacenan en UTC, y llegan como
// strings "YYYY-MM-DD HH:MM:SS" SIN marca de zona. Si se pasan directo a `new Date()`
// el navegador las interpreta como hora local, mostrando la hora corrida.
//
// Estas utilidades interpretan el valor como UTC y lo muestran SIEMPRE en hora de
// Colombia (America/Bogota = UTC-5, sin horario de verano), sin importar la zona
// del navegador del usuario.

const TZ = 'America/Bogota';

/**
 * Convierte un valor del backend a Date, tratándolo como UTC cuando no trae
 * marca de zona. Devuelve null si no es parseable.
 */
export const toDateUTC = (input) => {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;

  let s = String(input).trim();
  // Ya trae zona (Z u offset ±HH:MM) → parsear tal cual.
  if (/[zZ]$|[+-]\d{2}:?\d{2}$/.test(s)) {
    const d = new Date(s.replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
  }
  // "YYYY-MM-DD HH:MM[:SS]" sin zona → tratar como UTC.
  s = s.replace(' ', 'T');
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(s)) s += 'Z';
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
};

/** Fecha (sin hora) en hora Colombia. */
export const fmtFechaBogota = (input, opts) => {
  const d = toDateUTC(input);
  if (!d) return 'N/A';
  return d.toLocaleDateString('es-CO', {
    timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', ...(opts || {}),
  });
};

/** Fecha + hora en hora Colombia. */
export const fmtFechaHoraBogota = (input, opts) => {
  const d = toDateUTC(input);
  if (!d) return 'N/A';
  return d.toLocaleString('es-CO', {
    timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', ...(opts || {}),
  });
};
